import http from "../../utils/http";

export const createSign = (body) => {
  return new Promise((resolve, reject) => {
    http.post('/employees/sign', body)
      .then(res => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
  });
};

export const mySignList = (body = {}) => {
  return new Promise((resolve, reject) => {
    http.post('/employees/sign/my/list', body)
      .then(res => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
  });
};
export const changeAvailable = (idx, body) => {
  return new Promise((resolve, reject) => {
    http.put(`/employees/sign/available/${idx}`, body)
      .then(res => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
  });
};
export const deleteSign = (data) => {
  return new Promise((resolve, reject) => {
    http.delete('/employees/sign/delete', { data })
      .then(res => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
  });
};